import { useLogto } from '@logto/react';
import { Sentry } from '@/monitoring/sentry';

export function useAuth() {
  const { signIn, signOut, isAuthenticated, isLoading, getIdTokenClaims } = useLogto();

  const login = () => {
    signIn(`${window.location.origin}/callback`);
  };

  const logout = () => {
    Sentry.setUser(null);
    signOut(window.location.origin);
  };

  return {
    isAuthenticated,
    isLoading,
    login,
    logout,
    getIdTokenClaims,
  };
}
